import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { isValidEnumValue, MuiColor } from '../utility';
import { MuiI18nProvider } from '../i18n';

@Component({
  selector: 'mui-alert',
  templateUrl: './mui-alert.component.html'
})
export class MuiAlert {
  @Input() title = '';
  @Input() icon: string | null = null;
  @Input() color: MuiColor | string = MuiColor.INFO;
  @Input() class = '';
  @Input() dismissible = true;
  @Input() closeButtonLabel?: string;
  @Output() closed = new EventEmitter<void>();

  @HostBinding('attr.role')
  readonly role = 'alert';

  @HostBinding('attr.hidden')
  @HostBinding('attr.aria-hidden')
  hidden: boolean | null = null;

  @HostBinding('class') get buttonConfigClass(): string {
    const classes = [
      this.class, // include original classes from the DOM element
      'mui-alert',
      `mui-alert--${isValidEnumValue(MuiColor, this.color) ? this.color : MuiColor.INFO}`
    ];

    return classes.join(' ');
  }

  protected translations$: Observable<{ closeButton: string }>;

  constructor(private _i18n: MuiI18nProvider) {
    this.translations$ = this._i18n.alert();
  }

  close(): void {
    this.hidden = true;
    this.closed.emit();
  }
}
